import { useTranslation } from 'react-i18next';

export const keyPrefix = 'color_picker';
export const useColorPickerTranslation = () => useTranslation('shared', { keyPrefix });

export const ruRu = ({
  [keyPrefix]: {
    color: 'Цвет',
  },
}) as Record<string, unknown>;

export const en = ({
  [keyPrefix]: {
    color: 'Color',
  },
}) as Record<string, unknown>;

export const ptBr = ({
  [keyPrefix]: {
    color: 'Cor',
  },
}) as Record<string, unknown>;

export const esEs = ({
  [keyPrefix]: {
    color: 'Color',
  },
}) as Record<string, unknown>;
